import { Badge, Stack, StackProps } from "@chakra-ui/react";
import { Link } from "@areahub/ui/components/link/link";

export interface PostMetaProps extends StackProps {
  type:
    | "industrial hazards"
    | "natural hazards"
    | "infrastructure"
    | "pollution"
    | "products"
    | string;
  url: string | undefined;
}

export const categoryTagColors: Record<PostMetaProps["type"], string> = {
  "business insights": "blue",
  "industrial hazards": "teal",
  "natural hazards": "green",
  infrastructure: "orange",
  pollution: "purple",
  products: "indigo",
};

export const PostMeta = ({ type, url, ...rest }: PostMetaProps) => {
  return (
    <Stack
      spacing={{ base: "4", md: "6" }}
      direction={{ base: "column", md: "row" }}
      textTransform="uppercase"
      fontSize="xs"
      letterSpacing="wider"
      fontWeight="semibold"
      {...rest}
    >
      {url ? (
        <Link href={url}>
          <Badge
            alignSelf="flex-start"
            colorScheme={categoryTagColors?.[type?.toLowerCase()] || "gray"}
            variant="solid"
          >
            {type}
          </Badge>
        </Link>
      ) : (
        <Badge
          alignSelf="flex-start"
          colorScheme={categoryTagColors?.[type?.toLowerCase()] || "gray"}
          variant="solid"
        >
          {type}
        </Badge>
      )}
    </Stack>
  );
};
